//
//
//
//
//
//

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue